import React from 'react';
import { Button, Grid } from '@mui/material';
import UploadPicker from '../upload/UploadPicker';
import ValidTextFieldTS from './ValidTextFieldTS';
import { UploadContext } from '../upload/UploadContext';
import AddIcon from '@mui/icons-material/Add';
import DialogGlynt from '../common/Dialog/DialogGlynt';
import DialogTitleGlynt from '../common/Dialog/DialogTitleGlynt';
import DialogContentGlynt from '../common/Dialog/DialogContentGlynt';
import DialogActionsGlynt from '../common/Dialog/DialogActionsGlynt';

function TrainingSetCreate() {
  const {
    open,
    setUploading,
    setUploaded,
    setStep,
    setAcceptedDocs,
    setLabel,
    setOpen,
    display,
    step,
    uploading,
    uploaded,
    setOption,
    updateTotalUploadedDocs,
    updateTotalAcceptedDocs,
    updateTotalFailedDocs,
  } = React.useContext(UploadContext);
  const [disabled, setDisabled] = React.useState(true);

  const setUploadingLS = (value: boolean) => {
    localStorage.setItem('uploading', value + '');
    setUploading(value);
  };
  const resetModal = () => {
    setUploadingLS(false);
    setUploaded(false);
    setAcceptedDocs([]);
    setLabel('');
    setStep(1);
    setOpen(false);
    setOption(0);
    updateTotalUploadedDocs(0);
    updateTotalAcceptedDocs(0);
    updateTotalFailedDocs(0);
  };

  return (
    <>
      <Button
        data-cy="btn-create-training-set"
        disabled={false}
        startIcon={<AddIcon sx={{ fontSize: '16px !important' }} />}
        onClick={() => {
          setOpen(true);
          setUploaded(false);
        }}
        sx={{
          height: 32,
          px: 1.5,
          borderRadius: '6px',
          border: '1px solid #1D9AAA',
          bgcolor: '#fff',
          fontSize: '12.5px',
          fontWeight: 500,
          color: '#1D9AAA',
          textTransform: 'none',
          '&:hover': {
            borderColor: '#178a99',
            bgcolor: 'rgba(29,154,170,0.04)',
          },
          '&.Mui-disabled': {
            borderColor: '#BDC3D2',
            color: '#B0B0B0',
            bgcolor: '#fff',
          },
          '& .MuiButton-startIcon': { mr: 0.5 },
        }}
      >
        Create
      </Button>

      <DialogGlynt
        open={open && display}
        closeModal={resetModal}
        cypressId="dialog-create-training-set"
        width="600px"
      >
        <DialogTitleGlynt
          title={`Create New Training Set — Step ${step} of 2`}
          closeModal={resetModal}
        />

        {step === 1 ? (
          <>
            <DialogContentGlynt>
              <ValidTextFieldTS
                placeholder="Training Set Name"
                cypressId="input-new-training-set-name"
                setLabel={setLabel}
                disabled={uploaded || uploading}
                setDisabled={setDisabled}
              />
            </DialogContentGlynt>
            <DialogActionsGlynt
              handleSubmit={() => setStep(2)}
              closeModal={resetModal}
              cancelCypressId="training-set-new-dialog-cancel"
              submitCypressId="button-create-training-set-next"
              clearCypressId=""
              submitButtonText="Next"
              submitDisabled={disabled}
            />
          </>
        ) : (
          <>
            <DialogContentGlynt scrollable>
              <Grid container>
                <UploadPicker isExtraction={false} dismissModal={resetModal} />
              </Grid>
            </DialogContentGlynt>
            <DialogActionsGlynt
              handleSubmit={resetModal}
              closeModal={resetModal}
              cancelCypressId="training-set-new-dialog-cancel"
              submitCypressId="button-create-training-set-done"
              clearCypressId=""
              showSubmitButton={false}
            />
          </>
        )}
      </DialogGlynt>
    </>
  );
}

export default TrainingSetCreate;
